var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalkonSignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H6C2.68629 0 0 2.68629 0 6V27C0 30.3137 2.68629 33 6 33H27C30.3137 33 33 30.3137 33 27V6C33 2.68629 30.3137 0 27 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0.5H6C2.96243 0.5 0.5 2.96243 0.5 6V27C0.5 30.0376 2.96243 32.5 6 32.5H27C30.0376 32.5 32.5 30.0376 32.5 27V6C32.5 2.96243 30.0376 0.5 27 0.5Z",
    stroke: "#DCE1E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1829 21.6333C12.3057 18.0509 13.7979 13.5222 15.9931 10.6886C18.1882 7.85511 21.291 5.73567 24.7289 4.72174C23.1331 5.72258 21.8773 7.25488 21.1955 8.99932C20.713 9.08061 20.2578 9.31642 19.9129 9.6633C20.1843 9.66163 20.4558 9.65996 20.541 9.60066C19.882 11.9915 18.228 14.092 16.0579 15.2933C16.6064 15.3387 17.1707 15.148 17.674 14.8014C16.3962 17.111 13.5799 19.1082 12.1829 21.6333Z",
    fill: "url(#paint0_linear_106_593)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8842 21.6333C11.8842 17.9014 12.8505 14.3799 14.9466 11.2944C17.0426 8.20896 20.0449 5.7972 23.5847 4.62097C20.3196 4.96145 17.1047 6.20088 15.3591 9.39744C15.441 9.0191 15.5231 8.64048 15.605 8.26214C11.9187 11.6001 10.3783 16.91 11.8842 21.6333Z",
    fill: "url(#paint1_linear_106_593)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8327 21.9465C11.6476 22.8451 11.3666 23.6959 11 24.5033C12.0281 25.2032 12.5768 26.7566 13.0549 28.4362C13.0028 28.4743 12.9688 28.5359 12.9688 28.6058C12.9688 28.6946 13.0245 28.7703 13.1027 28.8012C13.1027 28.4543 13.1027 24.3001 13.1027 24.1085C12.9162 24.0726 12.7759 23.9092 12.7759 23.7126C12.7759 23.4902 12.9566 23.3092 13.1799 23.3092C13.4029 23.3092 13.5838 23.4899 13.5838 23.7124C13.5838 23.9089 13.4429 24.0723 13.257 24.1082C13.257 24.2998 13.257 28.454 13.257 28.8009C13.3352 28.77 13.3909 28.6943 13.3909 28.6055C13.3909 28.5359 13.3569 28.4743 13.3049 28.4359C13.7829 26.7564 14.3316 25.2029 15.3597 24.503C14.9931 23.6957 14.7119 22.8449 14.527 21.9462C14.4513 21.9465 11.9087 21.9465 11.8327 21.9465Z",
    fill: "url(#paint2_linear_106_593)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0086 18.8518C14.0574 19.6425 13.2327 20.5854 12.5754 21.6333C13.2681 21.6333 13.8074 21.6088 14.461 21.6088C14.363 20.6569 14.5855 19.675 15.0086 18.8518Z",
    fill: "url(#paint3_linear_106_593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_593",
    x1: 21.0639,
    y1: 6.55353,
    x2: 11.8189,
    y2: 21.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12A7EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_593",
    x1: 13.6557,
    y1: 21.9384,
    x2: 17.1072,
    y2: 11.3067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEC34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_593",
    x1: 13.1799,
    y1: 19.4679,
    x2: 13.1799,
    y2: 28.0707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12A7EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_593",
    x1: 13.2856,
    y1: 22.1313,
    x2: 14.0592,
    y2: 20.4344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEC34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonSignIcon);
export default __webpack_public_path__ + "static/media/falkon-sign-icon.053575d131369c079652a140a1ac7204.svg";
export { ForwardRef as ReactComponent };